export default __webpack_public_path__ + "locales/sr-Latn-RS/RoomLogoCover.json?hash=0f0234739f4620dd5390b86c03616a5f";